// Käuferdaten aus eingefügtem Text (seit 30.10.2026, Wunsch des Nutzers: „die
// Käuferdaten als Bulk in ein Feld kopieren, wo sich dann die Daten für die
// Felder extrahieren“). Typische Quellen: Adressblock, E-Mail-Signatur,
// Impressum, Handelsregisterauszug.
//
// Bewusst ohne KI: Die Regeln laufen sofort und offline, sind prüfbar (Test
// kaeuferAusText.test.js) und erfinden nichts. Was keiner Regel folgt, kommt
// als „nicht zugeordnet“ zurück, damit der Bearbeiter es sieht. Die Felder
// sind dieselben wie im Käufer-Block (normalizeBuyerDraft in vertragsStand.js).

const RECHTSFORMEN = [
  ['GmbH & Co. KG', /\bGmbH\s*&\s*Co\.?\s*KG\b/i],
  ['UG (haftungsbeschränkt)', /\bUG\s*\(haftungsbeschr(?:ä|ae)nkt\)/i],
  ['gGmbH', /\bgGmbH\b/],
  ['GmbH', /\bGmbH\b/i],
  ['KGaA', /\bKGaA\b/],
  ['PartG mbB', /\bPartG\s*mbB\b/],
  ['OHG', /\bOHG\b/],
  ['GbR', /\bGbR\b/],
  ['KG', /\bKG\b/],
  ['e.K.', /\be\.\s?K(?:fm|fr)?\./],
  ['e.V.', /\be\.\s?V\./],
  ['eG', /\beG\b/],
  ['UG', /\bUG\b/],
  // „AG“ und „SE“ nur am Ende des Namens - „AG Stendal“ ist das Amtsgericht.
  ['AG', /\sAG$/],
  ['SE', /\sSE$/],
];

// Beschriftungen am Zeilenanfang. Reihenfolge zählt: Telefax vor Telefon,
// Mobil vor Telefon. Wörter, die auf ä/ö/ü/ß enden, ohne \b (in JavaScript
// zählen Umlaute nicht als Wortzeichen).
const BESCHRIFTUNGEN = [
  ['email', /^(?:e-?mail(?:-?adresse)?|mail)\b\s*:?\s*/i],
  ['fax', /^(?:tele)?fax\b\s*:?\s*/i],
  ['mobile', /^(?:mobil(?:nummer|telefon|funk)?|handy|mobile|mob\.)\s*:?\s*/i],
  ['phone', /^(?:telefon|tel\.?|fon|phone|festnetz)\s*:?\s*/i],
  ['web', /^(?:website|webseite|web|internet|homepage|url)\b\s*:?\s*/i],
  ['vatId', /^(?:ust\.?\s*-?\s*id(?:ent)?\.?\s*-?\s*(?:nr\.?)?|ust-?idnr\.?|umsatzsteuer\s*-?\s*(?:identifikations\s*-?\s*(?:nummer|nr\.?)|id(?:\.?\s*-?\s*nr\.?)?)|vat(?:\s*(?:id|no\.?|number))?)\s*:?\s*/i],
  ['taxNumber', /^(?:steuer\s*-?\s*(?:nummer|nr\.?)|st\.?\s*-?\s*nr\.?|stnr\.?)\s*:?\s*/i],
  ['hrb', /^(?:handelsregisternummer|registernummer|hr-?nr\.?)\s*:?\s*/i],
  ['registerCourt', /^(?:registergericht|handelsregister|eingetragen\s+(?:im|beim)\s+(?:handelsregister|amtsgericht))\s*:?\s*/i],
  ['representatives', /^(?:vertreten\s+durch(?:\s+(?:den|die|das)\s+(?:geschäftsführerin|geschäftsführer|geschaeftsfuehrer(?:in)?|vorstand|inhaberin|inhaber|gesellschafter(?:in)?))?|geschäftsführende[rn]?\s+gesellschafter(?:in)?|geschäftsführerin|geschäftsführer|geschäftsführung|geschaeftsfuehr(?:erin|er|ung)|gf|vertretungsberechtigte?r?(?:\s+person)?|inhaberin|inhaber|vorstand)\s*:?\s*/i],
  ['legalForm', /^(?:rechtsform|geschäftsform|gesellschaftsform)\s*:\s*/i],
  ['seat', /^(?:sitz(?:\s+der\s+gesellschaft)?|firmensitz)\s*:\s*/i],
  ['company', /^(?:firmenname|firma|unternehmen|name|käufer|kaeufer|auftraggeber|kunde|investor)\s*:\s*/i],
  ['street', /^(?:straße|strasse|str\.|anschrift|adresse|postanschrift)\s*:\s*/i],
  ['postalCity', /^(?:plz\s*\/\s*ort|plz,?\s*ort|ort)\s*:\s*/i],
];

// „T: …“, „M: …“ in Signaturen - nur mit Doppelpunkt oder Punkt.
const KURZ = { T: 'phone', M: 'mobile', E: 'email', F: 'fax', W: 'web' };
const KURZ_MUSTER = /^([TMEFW])\s*[:.]\s+/;

const EMAIL = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/;
const WEB = /\b(?:https?:\/\/|www\.)\S+/i;
const UST_ID = /\bDE\s?\d{3}\s?\d{3}\s?\d{3}\b/;
const HR_NUMMER = /\bHR\s?([AB])\s*[:.]?\s*(\d{1,7}(?:\s?[A-Z]{1,2})?)\b/;
const STEUERNUMMER = /\b\d{2,3}\/\d{3,4}\/\d{4,5}\b/;
const AMTSGERICHT = /\bAmtsgericht\s+([^,;|]+?)(?=\s*(?:,|;|\||\bHR\s?[AB]\b|$))/i;
const AG_GERICHT = /^AG\s+([A-ZÄÖÜ][^,;|]*?)(?=\s*(?:,|;|\||\bHR\s?[AB]\b|$))/;
const TELEFON = /^(?:\+|00|0)[\d\s()/.\-–]{5,}$/;
const PLZ_ORT = /^(?:D\s?-\s?|DE\s?-\s?)?(\d{5})\s+([A-Za-zÄÖÜäöüß][^\d]*)$/;
const STRASSE = /^(.*[A-Za-zÄÖÜäöüß.])\s+(\d{1,5}\s?[a-zA-Z]?(?:\s?[-/]\s?\d{1,5}\s?[a-zA-Z]?)?)$/;
const STRASSE_UND_ORT = /^(.*[A-Za-zÄÖÜäöüß.]\s+\d{1,5}\s?[a-zA-Z]?)\s+((?:D\s?-\s?)?\d{5}\s+[A-Za-zÄÖÜäöüß].*)$/;
const ANREDE = /^(?:herrn?|frau|firma)\s+/i;

const text = (wert) => String(wert ?? '').replace(/\s+/g, ' ').trim();
const ziffern = (wert) => String(wert || '').replace(/\D/g, '');

/** Deutsche Mobilnummern beginnen national mit 015, 016 oder 017. */
function istMobilnummer(nummer) {
  let z = ziffern(nummer);
  // „+49 (0) 177 …“ / „0049 177 …“ → „0177 …“
  if (/^\+/.test(text(nummer)) || z.startsWith('00')) {
    z = `0${z.replace(/^0049|^49/, '').replace(/^0/, '')}`;
  }
  return /^01[5-7]/.test(z);
}

function rechtsformVon(name) {
  const treffer = RECHTSFORMEN.find(([, muster]) => muster.test(name));
  return treffer ? treffer[0] : '';
}

function gericht(wert) {
  const t = text(wert).replace(/^AG\s+/, '');
  if (!t) return '';
  return /^amtsgericht\b/i.test(t) ? t.replace(/^amtsgericht/i, 'Amtsgericht') : `Amtsgericht ${t}`;
}

function hrNummer(treffer) {
  return `HR${treffer[1].toUpperCase()} ${text(treffer[2])}`;
}

/** Trennt Angaben, die in einer Zeile stehen: „T: … · M: …“, „Straße | PLZ Ort“. */
const TRENNER = /\s*[;|•·\t]\s*/;

/** Teilt ein unbeschriftetes Stück weiter: „Musterweg 1, 12345 Ort“. */
function stueckeVon(teil) {
  return teil
    .split(/\s*,\s+/)
    .map(text)
    .filter(Boolean)
    .flatMap((stueck) => {
      const kombi = stueck.match(STRASSE_UND_ORT);
      return kombi ? [text(kombi[1]), text(kombi[2])] : [stueck];
    });
}

/**
 * @param {string} eingabe eingefügter Text
 * @returns {{ felder: Object<string, string>, erkannt: string[], uebrig: string[] }}
 *   `felder`: nur erkannte Felder (Schlüssel wie im Käufer-Block),
 *   `uebrig`: Angaben, die keinem Feld zugeordnet wurden, in der Reihenfolge der Eingabe.
 */
export function kaeuferAusText(eingabe) {
  const felder = {};
  const uebrig = []; // { pos, text }
  const vertreter = [];
  const strassen = [];
  const namen = [];
  let plzIndex = -1;

  const setze = (feld, wert) => {
    const t = text(wert);
    if (t && !felder[feld]) felder[feld] = t;
    return Boolean(t);
  };
  const liegenLassen = (pos, wert) => {
    const t = text(wert);
    if (t) uebrig.push({ pos, text: t });
  };

  // Gericht und Registernummer können in einem Stück stehen: „Amtsgericht Stendal HRB 22215“.
  const registerAus = (stueck) => {
    let rest = stueck;
    const hr = rest.match(HR_NUMMER);
    if (hr) {
      setze('hrb', hrNummer(hr));
      rest = text(rest.replace(hr[0], ' '));
    }
    const ag = rest.match(AMTSGERICHT) || rest.match(AG_GERICHT);
    if (ag) {
      setze('registerCourt', gericht(`Amtsgericht ${ag[1]}`));
      rest = text(rest.replace(ag[0], ' '));
    }
    return { gefunden: Boolean(hr || ag), rest: text(rest.replace(/^[,;:\s-]+|[,;:\s-]+$/g, '')) };
  };

  const ordneZu = (feld, wert, roh, pos) => {
    const t = text(wert);
    if (!t) return;
    switch (feld) {
      case 'email': {
        const m = t.match(EMAIL);
        if (m) setze('email', m[0]); else liegenLassen(pos, roh);
        break;
      }
      case 'fax':
      case 'web':
        liegenLassen(pos, roh);
        break;
      case 'vatId':
        setze('vatId', (t.match(UST_ID) || [t])[0]);
        break;
      case 'hrb': {
        const hr = t.match(HR_NUMMER);
        setze('hrb', hr ? hrNummer(hr) : t);
        break;
      }
      case 'registerCourt': {
        // „Registergericht: Stendal, HRB 1234“ – was neben der Nummer steht, ist das Gericht.
        const { rest } = registerAus(t);
        if (!felder.registerCourt) setze('registerCourt', gericht(rest));
        else liegenLassen(pos, rest);
        break;
      }
      case 'representatives':
        vertreter.push(t);
        break;
      case 'street':
        // „Anschrift: Musterweg 1, 12345 Musterstadt“
        stueckeVon(t).forEach((stueck) => {
          const m = stueck.match(PLZ_ORT);
          if (m) setze('postalCity', `${m[1]} ${text(m[2])}`);
          else setze('street', stueck);
        });
        break;
      case 'postalCity': {
        const m = t.match(PLZ_ORT);
        setze('postalCity', m ? `${m[1]} ${text(m[2])}` : t);
        break;
      }
      default:
        setze(feld, t);
    }
  };

  // Erst zerlegen, dann je Teil die Beschriftung prüfen. Jeder Teil behält
  // seine Position, damit „nicht zugeordnet“ in der Reihenfolge der Eingabe steht.
  const teile = String(eingabe || '')
    .split(/\r?\n/)
    .flatMap((zeile) => zeile.replace(/^[\s>*•\-–]+/, '').split(TRENNER))
    .map(text)
    .filter(Boolean);

  const stuecke = []; // { stueck, pos }
  teile.forEach((teil, pos) => {
    const kurz = teil.match(KURZ_MUSTER);
    if (kurz) {
      ordneZu(KURZ[kurz[1]], teil.slice(kurz[0].length), teil, pos);
      return;
    }
    const beschriftung = BESCHRIFTUNGEN.find(([, muster]) => muster.test(teil));
    if (beschriftung) {
      const [feld, muster] = beschriftung;
      ordneZu(feld, teil.replace(muster, ''), teil, pos);
      return;
    }
    stueckeVon(teil).forEach((stueck) => stuecke.push({ stueck, pos }));
  });

  stuecke.forEach(({ stueck: roh, pos }, index) => {
    let stueck = roh;
    const email = stueck.match(EMAIL);
    if (email) {
      setze('email', email[0]);
      stueck = text(stueck.replace(email[0], ' '));
      if (!stueck) return;
    }
    if (WEB.test(stueck)) {
      liegenLassen(pos, stueck);
      return;
    }
    const ust = stueck.match(UST_ID);
    if (ust) {
      setze('vatId', ust[0]);
      stueck = text(stueck.replace(ust[0], ' '));
      if (!stueck) return;
    }
    const register = registerAus(stueck);
    if (register.gefunden) {
      liegenLassen(pos, register.rest);
      return;
    }
    const steuer = stueck.match(STEUERNUMMER);
    if (steuer && !/[A-Za-zÄÖÜäöüß]{3,}/.test(stueck.replace(steuer[0], ''))) {
      setze('taxNumber', steuer[0]);
      return;
    }
    if (TELEFON.test(stueck) && ziffern(stueck).length >= 6) {
      setze(istMobilnummer(stueck) ? 'mobile' : 'phone', stueck);
      return;
    }
    const plz = stueck.match(PLZ_ORT);
    if (plz) {
      if (setze('postalCity', `${plz[1]} ${text(plz[2])}`) && plzIndex < 0) plzIndex = index;
      return;
    }
    if (rechtsformVon(stueck) && !felder.company) {
      setze('company', stueck);
      return;
    }
    if (STRASSE.test(stueck)) {
      strassen.push({ stueck, pos, index });
      return;
    }
    namen.push({ stueck, pos });
  });

  // Straße: das Stück direkt vor PLZ und Ort, sonst das erste.
  if (!felder.street && strassen.length) {
    const direkt = strassen.find((s) => s.index === plzIndex - 1) || strassen[0];
    setze('street', direkt.stueck);
    strassen.filter((s) => s !== direkt).forEach((s) => liegenLassen(s.pos, s.stueck));
  } else {
    strassen.forEach((s) => liegenLassen(s.pos, s.stueck));
  }

  // Ohne Rechtsform ist der Name das erste Stück ohne Ziffern - eine
  // Privatperson („Andreas Bachmann“). Die Anrede fällt weg.
  const name = felder.company
    ? null
    : namen.find((n) => !/\d/.test(n.stueck) && /[A-Za-zÄÖÜäöüß]{2,}/.test(n.stueck));
  if (name) setze('company', name.stueck.replace(ANREDE, ''));
  namen.filter((n) => n !== name).forEach((n) => liegenLassen(n.pos, n.stueck));

  if (vertreter.length) setze('representatives', vertreter.join(', '));

  const form = rechtsformVon(felder.company || '');
  if (form) setze('legalForm', form);
  // Sitz einer Gesellschaft: ohne eigene Angabe die Anschrift (wie bei den
  // gespeicherten Standardkunden, etwa Wolf Energy GmbH).
  if (form && felder.street && felder.postalCity) setze('seat', `${felder.street}, ${felder.postalCity}`);
  if (felder.company) setze('label', felder.company);

  const erkannt = Object.keys(felder).filter((feld) => feld !== 'label');
  const reihenfolge = [...uebrig].sort((a, b) => a.pos - b.pos).map((u) => u.text);
  return { felder, erkannt, uebrig: [...new Set(reihenfolge)] };
}

/** Anzeigenamen der Felder für die Rückmeldung nach dem Übernehmen. */
export const KAEUFER_FELDNAMEN = {
  company: 'Name/Firma',
  street: 'Straße',
  postalCity: 'PLZ/Ort',
  registerCourt: 'Registergericht',
  hrb: 'HRB',
  representatives: 'Vertreter',
  phone: 'Telefon',
  mobile: 'Mobil',
  email: 'E-Mail',
  vatId: 'USt-ID',
  taxNumber: 'Steuernummer',
  legalForm: 'Rechtsform',
  seat: 'Sitz',
};
